module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "index bg-light",
    staticStyle: {
      "min-height": "100vh"
    }
  }, [_c('div', {
    staticClass: "bg-white h-24 border-b border-solid border-gray-300 flex items-center"
  }, [_c('div', {
    staticClass: "container p-8 mx-auto"
  }, [_c('div', {
    staticClass: "md:flex md:items-center md:justify-between"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "mt-4 flex md:mt-0 md:ml-4"
  }, [_c('span', {
    staticClass: "ml-3 shadow-sm rounded-md"
  }, [_c('router-link', {
    staticClass: "bg-main border border-transparent inline-flex items-center px-4 py-2 text-sm leading-5 font-medium rounded-md text-white",
    attrs: {
      "tag": "button",
      "to": {
        name: 'CreateSwop'
      },
      "type": "button"
    }
  }, [_c('div', {
    staticClass: "flex items-center"
  }, [_vm._v("\n                                Opret SWOP\n                            ")])])], 1)])])])]), _vm._v(" "), _c('div', {
    staticClass: "page-content overflow-y-auto",
    staticStyle: {
      "height": "calc(100vh - 10rem)",
      "-webkit-overflow-scrolling": "touch"
    }
  }, [_c('div', {
    staticClass: "container p-8 mx-auto bg-light"
  }, [(_vm.swops && _vm.swops.length > 0) ? _c('div', {
    staticClass: "flex flex-wrap -mx-4"
  }, _vm._l((_vm.swops), function(swop) {
    return _c('div', {
      key: swop.id,
      staticClass: "w-1/3 px-4 mb-8 outline-none focus:outline-none hover:outline-none"
    }, [_c('router-link', {
      staticClass: "swop-card overflow-hidden bg-white shadow rounded leading-5",
      attrs: {
        "tag": "div",
        "to": {
          name: 'SingleSwop',
          params: {
            id: swop.id
          }
        }
      }
    }, [_c('div', {
      staticClass: "flex justify-end"
    }, [(swop.worker.color) ? _c('div', {
      staticClass: "w-full text-white py-2 px-6 text-sm text-center",
      staticStyle: {
        "background": "#ff0046"
      },
      style: ('background:' + swop.worker.color)
    }, [_vm._v("\n                                " + _vm._s(swop.worker.name) + "\n                            ")]) : _c('div', {
      staticClass: "w-full text-white py-2 px-6 text-sm text-center bg-main"
    }, [_vm._v("\n                                " + _vm._s(swop.worker.name) + "\n                            ")])]), _vm._v(" "), _c('div', {
      staticClass: "inner p-4"
    }, [_c('div', {
      staticClass: "flex justify-between text-gray-500"
    }, [_c('div', [_vm._v("\n                                    ID: " + _vm._s(swop.id) + "\n                                ")]), _vm._v(" "), _c('div', [_vm._v("\n                                    " + _vm._s(_vm.timeFromNow(swop.created_at)) + "\n                                ")])]), _vm._v(" "), _c('div', {
      staticClass: "text-3xl text-center font-semibold my-4 text-gray-900"
    }, [_vm._v("\n                                " + _vm._s(swop.serial) + "\n                            ")]), _vm._v(" "), _c('div', {
      staticClass: "flex justify-between text-gray-500"
    }, [_c('div', [_vm._v("\n                                    " + _vm._s(swop.container.name) + "\n                                ")]), _vm._v(" "), _c('div', [_c('div', {
      staticClass: "inline"
    }, [_vm._v("\n                                        " + _vm._s(swop.tests.length) + "\n                                        "), (swop.tests.length === 1) ? _c('span', [_vm._v("test")]) : _c('span', [_vm._v("tests")])])])])])])], 1)
  }), 0) : _vm._e()])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "flex-1 min-w-0"
  }, [_c('h2', {
    staticClass: "text-2xl font-bold leading-7 text-gray-900 sm:text-3xl sm:leading-9 sm:truncate"
  }, [_vm._v("\n                        Startside\n                    ")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-94c7567a"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/pages/common/index.vue
// module id = 294
// module chunks = 1